import React, { FC, SVGProps } from "react";

export const IconSend: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 20" fill="none" {...props}>
      <path
        d="M17.3311 2.5252C17.5133 2.46583 17.7138 2.51315 17.8497 2.64825C17.9855 2.78335 18.0341 2.98341 17.9756 3.16583L13.5303 16.8094C13.39 17.2304 12.9907 17.5098 12.5469 17.4988C12.1031 17.4879 11.7181 17.189 11.5987 16.7615L10.7276 13.1434L12.1504 8.77716C12.1894 8.65562 12.1569 8.52249 12.0665 8.43243C11.9759 8.34236 11.8422 8.30984 11.7208 8.34942L7.36041 9.7713L3.73638 8.90216C3.30974 8.78177 3.01087 8.39792 3.00006 7.95489C2.98929 7.51179 3.26913 7.1134 3.68951 6.97247L17.3311 2.5252Z"
        fill="currentColor"
      />
    </svg>
  );
};
